import React from 'react';
import { AlertTriangle } from 'lucide-react';

const HealthcareProblem = () => {
  const challenges = [
    'Rising patient expectations',
    'High turnover and staffing strain',
    'Regulatory and compliance pressure',
    'Telehealth and hybrid care models',
    'Inconsistent communication across roles and departments'
  ];

  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Modern Healthcare Demands More Than <span className="text-cyan-400">Clinical Skill</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-4xl mx-auto">
            Patient experience, safety, and communication now define quality care — but most healthcare teams were never trained for today's realities.
          </p>
        </div>

        <div className="max-w-3xl mx-auto mb-12">
          <p className="text-xl font-bold text-white mb-6 text-center">Healthcare organizations face:</p>
          <div className="space-y-4">
            {challenges.map((challenge, index) => (
              <div
                key={index}
                className="flex items-start gap-4 p-6 rounded-xl bg-gradient-to-br from-red-900/20 to-orange-900/20 border border-red-500/30"
              >
                <AlertTriangle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" />
                <p className="text-lg text-gray-300">{challenge}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-4xl mx-auto text-center">
          <div className="p-8 rounded-2xl bg-gradient-to-br from-cyan-900/20 to-blue-900/30 border border-cyan-500/30">
            <p className="text-xl text-white font-semibold">
              Traain delivers the enablement layer healthcare teams need to operate with clarity, confidence, and consistency.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HealthcareProblem;
